export default {
      id: "services-add-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#services-add",
      toString: function () {
        return this.url;
      }
    }